
import * as THREE from "three";
import { useThree, useFrame } from '@react-three/fiber'
import {useRef } from 'react'
import PointLight from "./3DComponents/PointLight";
import Group1 from "./3DComponents/Group1/Group1";
import Group2 from "./3DComponents/Group2/Group2";
import Group3 from "./3DComponents/Group3/Group3";
import Group4 from "./3DComponents/Group4/Group4";
import Tassels from "./3DComponents/Tassels";
import { lerp } from "./Utils";

export default function Components3D(props) {

    const group = useRef()

    var secondAnim = 0;

    var thirdAnim = 0;

    var fourthAnim = 0;

    useFrame(() => {
        
        var currentPos = new THREE.Vector3(0.0,0.0,0.0);
        var targetPos1 = new THREE.Vector3(0.0,-0.75,0.0);
        var targetPos2 = new THREE.Vector3(0.0,-1.57,0.0);
        var targetPos3 = new THREE.Vector3(0.0,-3.14,0.0);
        var targetPos4 = new THREE.Vector3(0.0,-4.71,0.0);


        var time = ( (window.scrollY - 1200) / window.innerHeight) /5;

        var time1 = ( (window.scrollY - secondAnim) / window.innerHeight) / 5;

        var time2 = ( (window.scrollY - thirdAnim) / window.innerHeight) / 5;

        var time3 = ( (window.scrollY - fourthAnim) / window.innerHeight) / 5;

        if(time < 0.99)
        {
            if( window.scrollY > 1200)
            {
                secondAnim = window.scrollY;
                group.current.rotation.y = lerp(currentPos.y, targetPos1.y, time)
              
            }
        }
        else
        {
            if(time1 < 0.99)
            {
                if(window.scrollY > secondAnim)
                {
                    thirdAnim = window.scrollY;
                    group.current.rotation.y = lerp(targetPos1.y, targetPos2.y, time1)
                }
               
            }
            else
            {
                if(time2 < 0.99)
                {
                    fourthAnim = window.scrollY;
                    group.current.rotation.y = lerp(targetPos2.y, targetPos3.y, time2)
                }
                else
                {
                    if(time3 < 0.99)
                    {
                        group.current.rotation.y = lerp(targetPos3.y, targetPos4.y, time3)
                    }
                }
            }

        }
             

    })


    // add three scene data here. Like fog
    const render = useThree()
    render.scene.fog = new THREE.Fog(props.data.fogColor, props.data.fogNear, props.data.fogFar)

    const hemiLight = useRef()


    return (

        <>
            

            <directionalLight
                color   = {props.data.dirLightColor}
                intensity = {props.data.dirLightIntensity}
                position = {[props.data.dirLightPosX,props.data.dirLightPosY,props.data.dirLightPosZ]}

            /> 

            <PointLight
                {...props}
            /> 

            <group
                position = {[0.0,0.0,-0.9]}
                ref = {group}
            >
                <hemisphereLight
                    ref={hemiLight}
                    color   = {props.data.lightColor}
                    groundColor  = {props.data.lightGroundColor}
                    intensity = {props.data.lightIntensity}
                    position = {[props.data.lightPosX,props.data.lightPosY,props.data.lightPosZ]}

                /> 

                <Tassels
                    {...props}
                    index = {1}
                ></Tassels>


                <Group1
                    {...props}
                    index = {1}
                    scrollIndex = {props.scrollIndex}
                />

                <Group2
                    {...props}
                    position={[-0.35, 0, -0.65]}
                    index = {1}
                />

                <Group3
                    {...props}
                    position={[0.25, 0, -0.65]}
                    index = {1}
                />

                <Group4
                    {...props}
                    position={[0, 0, -1.0]}
                    
                    index = {1}
                />

            </group>

        </>

  );
}
